import { gql } from '@apollo/client'
import { useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useRepliesState = () => React.useContext(Context) || {}
export const useReplies = () => useRepliesState()?.replies || []

const QUERY = gql`
  query Replies($page: Int, $search: String, $sort: ReplySort, $filter: ReplyFilter) {
    replies(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      value
      insertedAt
      serviceOrder {
        id
        user {
          id
          name
        }
      }
      formReply {
        id
        number
        formId
        place {
          id
          name
        }
      }
      question {
        id
        name
        category {
          id
          name
        }
        type {
          id
          name
        }
      }
    }
  }
`

const RepliesLoader = ({ children, uncontrolledChildren }) => {
  const filter = useModalData()
  const { field, type } = useSort()
  const search = useSearch()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: { page: 1, search, filter, sort: { field: field || 'INSERTED_AT', type: type || 'DESC' } },
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default RepliesLoader
